import { render, staticRenderFns } from "./CategoryAll.vue?vue&type=template&id=395aaa84&scoped=true&"
import script from "./CategoryAll.vue?vue&type=script&lang=js&"
export * from "./CategoryAll.vue?vue&type=script&lang=js&"
import style0 from "./CategoryAll.vue?vue&type=style&index=0&id=395aaa84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395aaa84",
  null
  
)

export default component.exports